import React, { useState, useEffect } from "react";
import AnnualHeadStats from "../components/annualViewNew/annualHeadStats";
import AnnualViewTabs from "../components/annualView/annualViewTabs";
import { annualViewTabs as AnnualViewTabsStyle } from "../css/styles/componentStyles";
import FinancialDashboard from "../components/annualView/Summary/summary";
import AnnualTotalTable from "../components/annualViewNew/annualTotalTable";
import { useSelector, useDispatch } from 'react-redux';
import DateFilterSelect from "../../../../../../CustomDatePicker/DateFilterSelectold";
import moment from "moment";
import Loader from '../../../../../../presentationals/Loader/Loader.component'
import { FILTER_ACTION } from '../../../../../../../reducers/CommonFilters.reducer';
import {
  getAnnualTotalReport,
  getRemainingSummary,
  getExpenseOverviewByDateRangeFilters,
  getExpenseMonthlyTableDASHboardsummaryByDateRangeFilters,
  getIncomeGrowhtByDateRangeFilters
} from "../utils/ActionCreator";

const AnnualView = () => {
  const dispatch = useDispatch();
  const { fromDate, toDate } = useSelector(state => state.FilterReduce.commonFilters);
  const [dateFilterPopup, setDateFilterPopup] = useState({ from: fromDate, to: toDate })
  const [accured, setAccured] = useState("")
  const [loader, setLoader] = useState(false)
  const [apiData, setApiData] = useState({ api1: {}, api2: {},api3:[] })

  const [activeTab, setActiveTab] = useState("annual");
  const [remainingSummary, setRemainingSummary] = useState({});
  const [annualTotalReport, setAnnualTotalReport] = useState({});

  // const fetchData = () => {
  //   const currentYear = new Date().getFullYear();
  //   const startDate = `${currentYear}-01-01`;
  //   const endDate = `${currentYear}-12-31`;

  //   getRemainingSummary(
  //     startDate,
  //     endDate,
  //     (callback) => {
  //       setRemainingSummary(callback);
        
  //     },
  //     (onErr) => {
  //       setRemainingSummary({});
        
  //     },
  //   );
  // };


  const handleDateFilterPopup = (type, val) => {
    setDateFilterPopup((prev) => ({ ...prev, [type]: val }));
    const formatted = moment(val).format("YYYY-MM-DD");

    setDateFilterPopup((prev) => {
      if (prev[type] === formatted) return prev;

      return {
        ...prev,
        [type]: formatted
      };
    });
    if (type === "from") {
      if (fromDate !== formatted) {
        dispatch({ type: FILTER_ACTION, payload: { "fromDate": formatted } });
      }
    } else {
      if (toDate !== formatted) {
        dispatch({ type: FILTER_ACTION, payload: { "toDate": formatted } });
      }
    }
  }

  useEffect(() => {
    if (
      fromDate !== dateFilterPopup.from ||
      toDate !== dateFilterPopup.to
    ) {
      setDateFilterPopup((prev) => ({
        ...prev,
        from: fromDate,
        to: toDate
      }));
    }
    const obj = { from: fromDate, to: toDate, accured: accured }
    MainApi(obj);
  }, [fromDate, toDate, accured]);


  const MainApi = (data) => {
    setLoader(true)
    getExpenseOverviewByDateRangeFilters(data?.from, data?.to, data?.accured ?? false, callback => {
      setApiData((prev) => ({
        ...prev,
        api1: callback ?? {}
      }))
    })
    getExpenseMonthlyTableDASHboardsummaryByDateRangeFilters(data?.from, data?.to, callback => {
      setApiData((prev) => ({
        ...prev,
        api2: callback ?? {}
      }))
    })
    getIncomeGrowhtByDateRangeFilters(data?.from, data?.to,data?.accured ?? false, callback => {
      setApiData((prev) => ({
        ...prev,
        api3: callback ?? []
      }))
    })

    setLoader(false)
  }



  return (
    <>
    {loader ? <Loader />:""}
      <div style={AnnualViewTabsStyle.container}>
        <div style={AnnualViewTabsStyle.tabContainer}>
         
          {/* <AnnualViewTabs activeTab={activeTab} setActiveTab={setActiveTab} /> */}
          <div
            style={AnnualViewTabsStyle.contentContainer}
            className="hide-scrollbar"
          >
            <div
              style={{
                ...AnnualViewTabsStyle.content,
                transform: `translateX(${activeTab === "annual" ? "0%" : "-50%"})`,
              }}
            >
              <div style={AnnualViewTabsStyle.panel}>
                 <div style={{ background: "#fff",
                  //  border: "1px solid rgb(217, 217, 217)",
                    padding: '10px', borderRadius: '8px', margin: "0 24px", 
                    // boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)" 
                    boxShadow: "rgb(179, 179, 179) 0px 2px 8px -1px",
                    marginBottom:'10px',
                    width:'stretch'
                    }}>
                    <div className="row">
                      <div className=" col-xs-12" style={{ display: 'flex', gap: "15px" }}>
                        <DateFilterSelect
                          value={[new Date(dateFilterPopup.from), new Date(dateFilterPopup.to)]}
                          onChange={(range) => {
                            handleDateFilterPopup("from", range[0]);
                            handleDateFilterPopup("to", range[1]);
                          }}
                          isFilterCleared={false}
                        />
                        <select value={accured} onChange={(e) => setAccured(e.target.value)} style={{ border: "1px solid rgb(204, 204, 204)", borderRadius: "8px", padding: "4px 10px" }}>
                          <option value={""}>Select Accurred</option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </select>
                      </div>
          
          
                    </div>
                  </div>
                <AnnualHeadStats remainingSummary={remainingSummary} apiData={apiData}/>
                <AnnualTotalTable apiData={apiData}/>
              </div>
              <div style={AnnualViewTabsStyle.panel}>
                {/* <AnnualHeadStats /> */}
                <FinancialDashboard />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AnnualView;
